<template>
    <el-dialog v-if="pageType === 'dialog'" v-model="dialogVisible" @closed="dialogClosed" class="form-dialog" :title="title" width="90%" :fullscreen="ismobile">
        <div class="dialog_tables_page">
            <tables
                :page-info="pageInfo"
                @update:topSearch="topSearch"
                @update:topBut="topBut"
                @update:nodeBut="nodeBut"
                @update:nodeSwitchChange="nodeSwitchChange"
                @update:nodeQuickEdit="nodeQuickEdit"
                @update:PageSizeChange="PageSizeChange"
                @update:toPage="toPage"
                @update:handleSelectionChange="handleSelectionChange"
                @update:sortChange="sortChange"
                @update:filterTime="filterTime"
                @update:selectList="selectList">
                <template v-slot:page_tips v-if="pageInfo && pageInfo.page_tips && pageInfo.page_tips.title">
                    <pagetips class="pagetips-box" :tip="pageInfo.page_tips"></pagetips>
                </template>
                <template v-slot:extra_html v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.content_top">
                    <div v-html="pageInfo.extra_html.content_top"></div>
                </template>
            </tables>
        </div>
    </el-dialog>

    <template v-else-if="pageType === 'tab'">
        <tables
            :page-info="pageInfo"
            @update:topSearch="topSearch"
            @update:topBut="topBut"
            @update:nodeBut="nodeBut"
            @update:nodeSwitchChange="nodeSwitchChange"
            @update:nodeQuickEdit="nodeQuickEdit"
            @update:PageSizeChange="PageSizeChange"
            @update:toPage="toPage"
            @update:handleSelectionChange="handleSelectionChange"
            @update:sortChange="sortChange"
            @update:filterTime="filterTime"
            @update:selectList="selectList">
            <template v-slot:page_tips v-if="pageInfo && pageInfo.page_tips && pageInfo.page_tips.title">
                <pagetips class="pagetips-box" :tip="pageInfo.page_tips"></pagetips>
            </template>
            <template v-slot:header_tabs>
                <el-header class="header-tabs">
                    <el-tabs type="card" v-model="pageCurrTab" @tab-change="tabChange">
                        <el-tab-pane v-for="(tab, index) in pageInfo.tab_nav.tab_list" :key="index" :label="tab" :name="index">
                        </el-tab-pane>
                    </el-tabs>
                </el-header>
            </template>
            <template v-slot:extra_html v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.content_top">
                <div v-html="pageInfo.extra_html.content_top"></div>
            </template>
        </tables>
    </template>

    <template v-else>
        <tables
            :page-info="pageInfo"
            @update:topSearch="topSearch"
            @update:topBut="topBut"
            @update:nodeBut="nodeBut"
            @update:nodeSwitchChange="nodeSwitchChange"
            @update:nodeQuickEdit="nodeQuickEdit"
            @update:PageSizeChange="PageSizeChange"
            @update:toPage="toPage"
            @update:handleSelectionChange="handleSelectionChange"
            @update:sortChange="sortChange"
            @update:filterTime="filterTime"
            @update:selectList="selectList">
            <template v-slot:page_tips v-if="pageInfo && pageInfo.page_tips && pageInfo.page_tips.title">
                <pagetips class="pagetips-box" :tip="pageInfo.page_tips"></pagetips>
            </template>
            <template v-slot:extra_html v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.content_top">
                <div v-html="pageInfo.extra_html.content_top"></div>
            </template>
        </tables>
    </template>
</template>

<script>
    import { defineComponent, getCurrentInstance, inject, ref, provide, reactive, toRefs, computed } from 'vue'
    import { useLayoutStore } from '@/store'
    import Tables from './table'
    import Pagetips from '../ui-form-page/pagetips'

    export default defineComponent({
        components: {
            Tables,
            Pagetips
        },
        props: {
            isMiniPage: {
                type: Boolean,
                default: false
            },
            pageType: {
                type: String,
                default: 'page'
            },
            pageInfo: {
                type: Object || Array,
                default: () => { }
            }
        },
        setup(props, context) {
            const StoreLayout = useLayoutStore()
            const ismobile = computed(() => StoreLayout.ismobile)
            const pageCurrTab = ref()
            const dialogVisible = inject('dialogVisible')
            if (props.pageType === 'tab') {
                pageCurrTab.value = props.pageInfo.tab_nav.curr_tab
            }
            const tabChange = (e) => {
                context.emit('update:onTabChange', e)
            }
            const dialogClosed = () => {
                context.emit('update:dialogClosed')
            }

            const topSearch = (f, k) => {
                props.isMiniPage && context.emit('update:topSearch', f, k)
            }

            const topBut = (e, href) => {
                props.isMiniPage && context.emit('update:topBut', e, href)
            }

            const nodeBut = (e, a, href) => {
                props.isMiniPage && context.emit('update:nodeBut', e, a, href)
            }

            const nodeSwitchChange = (a, b, c) => {
                props.isMiniPage && context.emit('update:nodeSwitchChange', a, b, c)
            }
            const nodeQuickEdit = (a, b, c) => {
                props.isMiniPage && context.emit('update:nodeQuickEdit', a, b, c)
            }
            const PageSizeChange = (e) => {
                props.isMiniPage && context.emit('update:PageSizeChange', e)
            }
            const toPage = (e) => {
                props.isMiniPage && context.emit('update:toPage', e)
            }

            const handleSelectionChange = (e) => {
                props.isMiniPage && context.emit('update:handleSelectionChange', e)
            }

            const sortChange = (e) => {
                props.isMiniPage && context.emit('update:sortChange', e)
            }

            const filterTime = (e) => {
                props.isMiniPage && context.emit('update:filterTime', e)
            }
            const selectList = (a, b) => {
                props.isMiniPage && context.emit('update:selectList', a, b)
            }

            return {
                ismobile,
                pageCurrTab,
                tabChange,
                dialogVisible,

                topSearch,
                topBut,

                nodeBut,
                nodeSwitchChange,
                nodeQuickEdit,

                PageSizeChange,
                toPage,

                handleSelectionChange,
                sortChange,
                filterTime,
                selectList,

                dialogClosed
            }
        }
    })
</script>

<style scoped>
</style>
